export const waitMs = async (ms: number) =>
  new Promise(resolve => setTimeout(resolve, ms));
